<template>
  <CPagination
    :active-page.sync="lPage"
    :pages="Math.ceil(total / size)"
    align="end"
  />
</template>
<script>
export default {
  name: "ContentPagination",
  props: ["page", "total", "size"],
  data() {
    return {
      lPage: 1,
    };
  },
  created() {
    this.lPage = this.page;
  },
  watch: {
    lPage(p) {
      if (!p) {
        p = 1;
      }
      this.$emit("input", p);
    },
  },
};
</script>